import { Component, OnInit } from '@angular/core';
import { EventService } from 'src/app/core/services/event.service';
import { EventType } from 'src/app/core/constants/events';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  isDarkTheme: boolean = false;

  constructor(private eventService: EventService) {}

  ngOnInit(): void {
    const theme = localStorage.getItem('cayc-ui-theme');
    this.isDarkTheme = theme === 'dark';
    this.eventService.on(EventType.CHANGE_LAYOUT_COLOR).subscribe((event) => {
      this.isDarkTheme = event.payload === 'dark';
    });
  }
}
